var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z",
    fill: "#D01400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74234 8.00034L10.3523 6.39034C10.5553 6.18734 10.5553 5.85134 10.3523 5.64834C10.1493 5.44534 9.81334 5.44534 9.61034 5.64834L8.00034 7.25834L6.39034 5.64834C6.18734 5.44534 5.85134 5.44534 5.64834 5.64834C5.44534 5.85134 5.44534 6.18734 5.64834 6.39034L7.25834 8.00034L5.64834 9.61034C5.44534 9.81334 5.44534 10.1493 5.64834 10.3523C5.75334 10.4573 5.88634 10.5063 6.01934 10.5063C6.15234 10.5063 6.28534 10.4573 6.39034 10.3523L8.00034 8.74234L9.61034 10.3523C9.71534 10.4573 9.84834 10.5063 9.98134 10.5063C10.1143 10.5063 10.2473 10.4573 10.3523 10.3523C10.5553 10.1493 10.5553 9.81334 10.3523 9.61034L8.74234 8.00034Z",
    fill: "#D01400",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFail);
export default __webpack_public_path__ + "static/media/ic_fail.9d79f68c6f401ac04aa1bf4b3e38f29b.svg";
export { ForwardRef as ReactComponent };